import { Box, Flex } from '@chakra-ui/react';
import SkillBox from '../components/SkillBox';
import { FaJava, FaPython, FaHtml5, FaGithub, FaNode, FaFigma, FaUnity, FaAws } from "react-icons/fa";
import { SiTypescript, SiJavascript, SiReact, SiCss3, SiJira, SiDiscord, SiCanva, SiXcode, SiAndroidstudio, SiExpo, SiFirebase, SiTwilio, SiPostman } from "react-icons/si";
import { DiScrum } from "react-icons/di";
import Marquee from "react-fast-marquee";

const skills = [
	{
		title: "Postman",
		icon: <SiPostman />,
		color: "#FF713D",
		link: "https://www.postman.com/"
	},
	{
		title: "Java",
		icon: <FaJava />,
		color: "#ED272C",
		link: "https://www.java.com/en/"
	},
	{
		title: "HTML5",
		icon: <FaHtml5 />,
		color: "#DD4B25",
		link: "https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/HTML5"
	},
	{
		title: "Node.js",
		icon: <FaNode />,
		color: "#509941",
		link: "https://nodejs.org/en/"
	},
	{
		title: "Unity",
		icon: <FaUnity />,
		color: "#848484",
		link: "https://unity.com/"
	},
	{
		title: "Scrum",
		icon: <DiScrum />,
		color: "#0169B4",
		link: "https://www.scrum.org/"
	},
	{
		title: "Discord",
		icon: <SiDiscord />,
		color: "#5562EA",
		link: "https://discord.com/"
	},
	{
		title: "Xcode",
		icon: <SiXcode />,
		color: "#1FB0F0",
		link: "https://developer.apple.com/xcode/"
	},
	{
		title: "JavaScript",
		icon: <SiJavascript />,
		color: "#FFD600",
		link: "https://developer.mozilla.org/en-US/docs/Web/JavaScript"
	},
	{
		title: "CSS3",
		icon: <SiCss3 />,
		color: "#254BDF",
		link: "https://developer.mozilla.org/en-US/docs/Web/CSS"
	},
	{
		title: "Jira",
		icon: <SiJira />,
		color: "#2580F7",
		link: "https://www.atlassian.com/software/jira"
	},
	{
		title: "GitHub",
		icon: <FaGithub />,
		color: "#374151",
		link: "https://www.github.com/"
	},
	{
		title: "AWS",
		icon: <FaAws />,
		color: "#FF9C08",
		link: "https://aws.amazon.com/"
	},
	{
		title: "Firebase",
		icon: <SiFirebase />,
		color: "#FFCD32",
		link: "https://firebase.google.com/"
	},
	{
		title: "Python",
		icon: <FaPython />,
		color: "#F5D85A",
		link: "https://www.python.org/"
	},
	{
		title: "TypeScript",
		icon: <SiTypescript />,
		color: "#007ACC",
		link: "https://www.typescriptlang.org/"
	},
	{
		title: "Twilio",
		icon: <SiTwilio />,
		color: "#EF384E",
		link: "https://www.twilio.com/"
	},
	{
		title: "Figma",
		icon: <FaFigma />,
		color: "#A55EFF",
		link: "https://www.figma.com/"
	},
	{
		title: "Expo",
		icon: <SiExpo />,
		color: "#848484",
		link: "https://expo.dev/"
	},
	{
		title: "Canva",
		icon: <SiCanva />,
		color: "#08C6CE",
		link: "https://www.canva.com/"
	},
	{
		title: "React",
		icon: <SiReact />,
		color: "#61DAFB",
		link: "https://reactjs.org/"
	},
	{
		title: "And. Studio",
		icon: <SiAndroidstudio />,
		color: "#4BDE8E",
		link: "https://developer.android.com/studio"
	}
];

/**
 * The skills section of the site.
 * @returns The section of the site that displays the skills I'm good with
 */
export default function Skills() {

	return (
		<Flex
			id='skills'
			flexDirection={"column"}
			alignItems="center"
			justifyContent="space-between"
			backgroundColor={"black.300"}
			minW={"100%"}
			maxW={"100%"}
		>
			{/* Title */}
			<Box
				fontSize={"4xl"}
				fontFamily={"Source Code Pro Variable"}
				fontWeight="600"
                width={"100%"}
                textAlign={"center"}
				color={"white.200"}
				padding={"5%"}
			>
				Some tech I'm good with:
			</Box>

			{/* Skills Row Container */}
			<Flex
				flexDirection={"column"}
				width={"100%"}
				alignItems={"center"}
				justifyContent={"center"}
			>
				{/* Top Row */}
				<Marquee
					speed={50}
					autoFill={true}
					style={{
						marginBottom: "2%",
						padding: "0",
						height: "150px"
					}}
				>
					{skills.slice(0, skills.length / 2).map((skill, index) => (
						<SkillBox
							title={skill.title}
							icon={skill.icon}
							color={skill.color}
							link={skill.link}
							key={index}
						/>
					))}
				</Marquee>

				{/* Bottom Row */}
				<Marquee
					speed={60}
					autoFill={true}
					style={{
						marginBottom: "5%",
						padding: "0",
						height: "150px",
					}}
				>
					{skills.slice(skills.length / 2, skills.length).map((skill, index) => (
						<SkillBox
							title={skill.title}
							icon={skill.icon}
							color={skill.color}
							link={skill.link}
							key={index}
						/>
					))}
				</Marquee>
			</Flex>
		</Flex>
	);
};
